export enum enumReportType {
  SQL = 'SQL',
  Custom = 'Custom'
}


export namespace enumReportType {
  export function values() {
    return Object.keys(enumReportType).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
